(function () {
  // Rituaali koosseisurea vihjemull (snippets/ritual-tip.liquid) — puutel
  // sulgemisviis (auditi leid M-4). CSS `:hover` katab hiire, see fail
  // katab puute: klõps/koputus avab-sulgeb, Escape sulgeb, klõps mujale
  // sulgeb. Asendab `:focus-within` reegli, mis jättis mulli lahti kuni
  // kasutaja vajutas mujale, ilma väljumisviisita.

  function closeAll(except) {
    document.querySelectorAll('.rit-tip[data-open="true"]').forEach(function (tip) {
      if (tip === except) return;
      tip.removeAttribute('data-open');
      const button = tip.querySelector('.rit-tip__more');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest?.('.rit-tip__more');
    const tip = event.target.closest?.('.rit-tip');

    if (button) {
      event.preventDefault();
      const parent = button.closest('.rit-tip');
      const isOpen = parent.getAttribute('data-open') === 'true';
      closeAll(parent);
      if (isOpen) {
        parent.removeAttribute('data-open');
        button.setAttribute('aria-expanded', 'false');
      } else {
        parent.setAttribute('data-open', 'true');
        button.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (!tip) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
